export default __webpack_public_path__ + "static/media/Eggchartpng.16b4edc3.png";